export enum TrailAlignment {
    /** 使拖尾面向摄像机。*/
    View,
    /** 使拖尾的与组件的方向对齐*/
    TransformZ
}
